import React from 'react';

const SiteBySpecialtyItem = ({ specialty }) => {
  return (
    <div 
      data-testid="specialty-item"
      className="w-full h-14 px-2 py-1.5 bg-white border-b border-neutral-200 flex items-center justify-between"
    >
      <div 
        data-testid="specialty-name"
        className="text-primary text-sm font-normal font-['Inter'] leading-tight"
      >
        {specialty?.specialty}
      </div>
      <div 
        data-testid="specialty-count"
        className="text-right text-primary text-base font-normal font-['Inter'] leading-normal"
      >
        {specialty?.count}
      </div>
    </div>
  );
};

export default SiteBySpecialtyItem;
